import { useForm } from "react-hook-form";
import { Error, Label } from "../../shared/Components";
import Icon from "../../assets/icons/Icon";
import { API_CHANGE_PASSWORD } from "../../utils/api/ApiConstant";
import { postAxios } from "../../shared/Services/commonService";
import showToast from "../../utils/toastUtil";

const INITIAL_DATA = {
  current: {
    isText: false,
    value: "",
  },
  new: {
    isText: false,
    value: "",
  },
  confirm: {
    isText: false,
    value: "",
  },
};

const getInitialData = () => ({
  current: { ...INITIAL_DATA.current },
  new: { ...INITIAL_DATA.new },
  confirm: { ...INITIAL_DATA.confirm },
});

const ChangePassword = ({ handleModalHide }) => {
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    watch,
    formState: { errors },
    setFocus,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: getInitialData(),
  });

  const values = watch();

  const onSubmit = async (formValues) => {
    clearErrors();

    const oldPassword = formValues.current.value?.trim();
    const newPassword = formValues.new.value?.trim();
    const confirmPassword = formValues.confirm.value?.trim();

    if (oldPassword === newPassword) {
      setError("new.value", {
        type: "manual",
        message: "New password must be different from your current password",
      });
      setFocus("new.value");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("confirm.value", {
        type: "manual",
        message: "Confirm password must match the new password",
      });
      setFocus("confirm.value");
      return;
    }

    const payload = { oldPassword, newPassword, confirmPassword };
    const response = await postAxios(API_CHANGE_PASSWORD, payload);
    console.log("🚀 ~ onSubmit ~ response:", response);

    if (response?.errors?.length > 0) {
      const fieldMap = {
        OldPassword: "current.value",
        NewPassword: "new.value",
        ConfirmPassword: "confirm.value",
      };

      response.errors.forEach(({ field, message }, index) => {
        const key = fieldMap[field];

        if (key) {
          setError(key, {
            type: "manual",
            message,
          });

          if (index === 0) {
            setFocus(key);
          }
        }
      });

      return;
    }

    if (response) {
      handleClear();
      handleShowHide?.();
    }
  };

  const handleIconClick = (name) => {
    setValue(`${name}.isText`, !values[name].isText, {
      shouldDirty: false,
      shouldTouch: false,
    });
  };

  const handleClear = () => {
    setFocus("current.value");
    reset(getInitialData());
    handleModalHide?.();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <Label
              htmlFor="current-password"
              className="form-label"
              isRequired={true}
            >
              Current Password
            </Label>
            <div className="password-field">
              <input
                type={values.current.isText ? "text" : "password"}
                id="current-password"
                className="form-control"
                placeholder="Enter current password"
                {...register("current.value", {
                  required: "Required",
                  minLength: {
                    value: 2,
                    message: "Minimum 2 characters required",
                  },
                  maxLength: {
                    value: 25,
                    message: "Maximum 25 characters allowed",
                  },
                })}
                autoFocus={true}
                tabIndex={1}
                onFocus={(e) => e.target.select()}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => handleIconClick("current")}
              >
                <Icon name={values.current.isText ? "EyeClosed" : "Eye"} />
              </button>
            </div>
            {errors.current?.value && (
              <Error>{errors.current.value.message}</Error>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="form-group">
            <Label
              htmlFor="new-password"
              className="form-label"
              isRequired={true}
            >
              New Password
            </Label>
            <div className="password-field">
              <input
                type={values.new.isText ? "text" : "password"}
                id="new-password"
                className="form-control"
                placeholder="Enter new password"
                {...register("new.value", {
                  required: "Required",
                  minLength: {
                    value: 2,
                    message: "Minimum 2 characters required",
                  },
                  maxLength: {
                    value: 25,
                    message: "Maximum 25 characters allowed",
                  },
                })}
                tabIndex={2}
                onFocus={(e) => e.target.select()}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => handleIconClick("new")}
              >
                <Icon name={values.new.isText ? "EyeClosed" : "Eye"} />
              </button>
            </div>
            {errors.new?.value && <Error>{errors.new.value.message}</Error>}
          </div>
        </div>

        <div className="col-12">
          <div className="form-group">
            <Label
              htmlFor="confirm-password"
              className="form-label"
              isRequired={true}
            >
              Confirm Password
            </Label>
            <div className="password-field">
              <input
                type={values.confirm.isText ? "text" : "password"}
                id="confirm-password"
                className="form-control"
                placeholder="Enter confirm password"
                {...register("confirm.value", {
                  required: "Required",
                  minLength: {
                    value: 2,
                    message: "Minimum 2 characters required",
                  },
                  maxLength: {
                    value: 25,
                    message: "Maximum 25 characters allowed",
                  },
                })}
                tabIndex={3}
                onFocus={(e) => e.target.select()}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => handleIconClick("confirm")}
              >
                <Icon name={values.confirm.isText ? "EyeClosed" : "Eye"} />
              </button>
            </div>
            {errors.confirm?.value && (
              <Error>{errors.confirm.value.message}</Error>
            )}
          </div>
        </div>

        <div className="col-12 mt-3">
          <div className="form-group mb-0">
            <div className="d-flex justify-content-end w-100 gap-2">
              <button
                type="button"
                className="btn btn_main btn_muted px-3 py-2"
                onClick={handleClear}
                tabIndex={5}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn_main px-3 py-2"
                tabIndex={4}
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ChangePassword;
